import React from 'react';

const Default = () => {
    return (
        <p />
    )
}

export default Default;